// extracted by mini-css-extract-plugin
export var header = "navbar-module--header--3Yuff";
export var streamingNow = "navbar-module--streamingNow--sMbYn";
export var navLogos = "navbar-module--navLogos---+zi5";
export var logoRow = "navbar-module--logoRow--gZcKm";
export var navLinks = "navbar-module--navLinks--opwVN";
export var navLink = "navbar-module--navLink--iEe91";